import React, { useRef, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import InputGroup from 'react-bootstrap/InputGroup';

import kenyaImg from '../Images/kenyaflag.png'
import ugandaFlag from '../Images/ugandaflag.png'
import Alert from 'react-bootstrap/Alert';


//routers
import {Link } from "react-router-dom";
import Logo from '../Images/thelogo.png'
import swal from 'sweetalert';

function Login() {


    const [showProgress, setShowProgress] = useState(false);
    const [showSignInbtn, setShowSignInbtn] = useState(true);
    const [countryLogo, setcountryLogo] = useState(kenyaImg);
    const [userCode, setUserCode] = useState("+254");
    const [show, setShow] = useState(false);


    const phoneRef = useRef();
    const countryRef = useRef();



    function loginUser(){
        setShow(true);

    }

    const [selectedOption, setSelectedOption] = useState('');

    const handleSelectChange = (event) => {
        const selectedValue = event.target.value;
        setSelectedOption(selectedValue);

        if(selectedValue == "Kenya"){

            setUserCode("+254");
            setcountryLogo(kenyaImg)

        }else if (selectedValue == "Uganda"){
            setUserCode("+256");
            setcountryLogo(ugandaFlag)
        }
        
    };

    function openLinkToApp(){
        window.location.href = "https://play.google.com/store/apps/details?id=com.kiota.logistics";
    }





  return (
    <div className='mainAuth'>

        <div className='AuthLeft'>

          <div className='authleftCont'>
            <video autoPlay muted loop src="https://res.cloudinary.com/ubunifu/video/upload/v1691341770/pexels-polina-tankilevitch-6700838_1080p_djbwge.mp4"></video>
            <div className='authLeftOpacity'></div>
          </div>
          

        </div>

        <div className='AuthRight'>

            <img src={Logo} alt="" className='logoAuth' />
            <p>You will receive a 6 digit code to verify next</p>
            <InputGroup className="mb-3">
            <InputGroup.Text id="basic-addon1">
                <img src={countryLogo}  className='countryIcon' alt="" />
            
            </InputGroup.Text>
              <Form.Select aria-label="Default select example" value={selectedOption} onChange={handleSelectChange}>
                <option value="Kenya">Kenya</option>
                <option value="Uganda">Uganda</option>
             </Form.Select>
             </InputGroup>

             <InputGroup className="mb-3">
                <InputGroup.Text id="basic-addon1">{userCode}</InputGroup.Text>
                <Form.Control
                placeholder="phone number"
                aria-label="Username"
                aria-describedby="basic-addon1"
                type="number" 
                className='myForms'
                />
            </InputGroup>
 
 
           


              {showSignInbtn && 
              <button variant="primary" type="submit" className='btnLogin' onClick={loginUser}>
              Continue
              </button>
              }

              {showProgress && 
                  <Button variant="primary" disabled  className='btnLogin'>
                      <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      />
                      <span> Signing in...</span>
                  </Button>
              }

                <Alert show={show} variant="primary" className='downloadApp'>
                    <Alert.Heading>Under Maintainance</Alert.Heading>
                    <p>
                    Hey, our web application is still under maintanace. Please download the mobile app.
                    </p>
                    <hr />
                    <div className="d-flex justify-content-end">
                    <Button onClick={openLinkToApp} variant="outline-primary">
                        Download Mobile App
                    </Button>
                    </div>
                </Alert>

               

     

        </div>
    </div>
  )
}

export default Login